var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486 486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:#77838b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "letter-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    className: "cls-1",
    cx: 243,
    cy: 243,
    r: 243
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M383.6,379.8H101.4a19.2,19.2,0,0,1-19.2-19.2V213.7a19.3,19.3,0,0,1,8-15.6l28.3-20.3,4,5.6L94.3,203.8a12.3,12.3,0,0,0-5.1,10V360.6a12.3,12.3,0,0,0,12.3,12.3H383.6a12.3,12.3,0,0,0,12.3-12.3V213.7a12.3,12.3,0,0,0-5.2-10l-21.3-15.3,4-5.6,21.3,15.3a19.3,19.3,0,0,1,8.1,15.6V360.6a19.2,19.2,0,0,1-19.2,19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-2",
    d: "M390.4,372.2l-137-94.5a18.9,18.9,0,0,0-21.8,0l-137,94.5-4-5.7,137-94.5a25.9,25.9,0,0,1,29.8,0l136.9,94.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    className: "cls-2",
    x: 268.1,
    y: 250.6,
    width: 141.7,
    height: 6.97,
    transform: "translate(-82.9 215.5) rotate(-31.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-2",
    "data-name": "Rectangle-path",
    className: "cls-2",
    x: 141.4,
    y: 185.3,
    width: 7,
    height: 139.04,
    transform: "matrix(0.52, -0.85, 0.85, 0.52, -148.04, 244.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-2",
    points: "124 240.5 117 240.5 117 94.2 374.9 94.2 374.9 233.5 368 233.5 368 101.2 124 101.2 124 240.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-3",
    "data-name": "Rectangle-path",
    className: "cls-2",
    x: 156.6,
    y: 133.1,
    width: 81.3,
    height: 6.97
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-4",
    "data-name": "Rectangle-path",
    className: "cls-2",
    x: 156.6,
    y: 188.8,
    width: 151,
    height: 6.97
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-5",
    "data-name": "Rectangle-path",
    className: "cls-2",
    x: 156.6,
    y: 209.7,
    width: 151,
    height: 6.97
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-6",
    "data-name": "Rectangle-path",
    className: "cls-2",
    x: 156.6,
    y: 230.6,
    width: 122.1,
    height: 6.97
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path-7",
    "data-name": "Rectangle-path",
    className: "cls-2",
    x: 156.6,
    y: 154,
    width: 60.4,
    height: 6.97
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterSmall);
export default __webpack_public_path__ + "static/media/letter-small.1502f72b24785358da9a88fa9804bd6c.svg";
export { ForwardRef as ReactComponent };